import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IAppConfig } from '../models/app-config';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // Static config storage - set before Angular bootstrap in main.ts
  private static preloadedConfig: IAppConfig | undefined;

  private appConfig: IAppConfig | undefined;
  private httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
    // Use pre-loaded config if available
    if (ConfigService.preloadedConfig) {
      this.appConfig = ConfigService.preloadedConfig;
    }
  }

  /**
   * Set the config before Angular bootstrap to avoid race conditions.
   * Called from main.ts after fetching the config.
   */
  static setPreloadedConfig(config: IAppConfig): void {
    ConfigService.preloadedConfig = config;
  }

  async loadAppConfig(configUrl: string): Promise<void> {
    // Skip if config was already preloaded
    if (this.appConfig) {
      return;
    }
    try {
      this.appConfig = await firstValueFrom(this.httpClient.get<IAppConfig>(configUrl));
    } catch (err) {
      console.error('Error loading app configuration', err);
      // Handle error appropriately, maybe show an error page
    }
  }

  getConfig(): IAppConfig {
    if (!this.appConfig) {
      throw new Error('App config not loaded!');
    }
    return this.appConfig;
  }

  get auth0(): IAppConfig['auth0'] {
    return this.getConfig().auth0;
  }

  get api(): IAppConfig['api'] {
    return this.getConfig().api;
  }
}
